/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-26 17:35:04
 * @LastEditTime: 2022-01-26 22:15:25
 * @LastEditors: zhao - 🍉
 * @Description: 租金宝同步数据 - 项目详情
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/components/ProjectDetailListModal.jsx
 */
import { Button, Modal } from 'antd'
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import ModalScrollContainer from "../../../components/ModalScrollContainer";
import TableHelper from '../../../components/TableHelper'
import { fetchZJBSyncDataProjectInfo } from '../../../services/ZJBSyncDataRecord'
import { commonIsMap, dicBuildingStatus, dicRecvCertType, mapZJBSyncDataDetailType } from "../../../axios/dictionaries";
import { findDict, formatTime } from '../../../utils';


const ProjectDetailListModal = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const [defaultSearch, setDefaultSearch] = useState(null);
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (operationType, syncDate) => {
        setVisible(true)
        setDefaultSearch({ operationType, syncStartDate: syncDate, syncEndDate: syncDate })
    }
    const close = () => {
        setVisible(false)
        setDefaultSearch(null)
    }
    const columns = [
        { title: '项目名称', dataIndex: 'name', },
        { title: '项目编号', dataIndex: 'projectNo', },
        { title: '账户账号', dataIndex: 'balanceAcc', },
        { title: '开户行网点号', dataIndex: 'balanceAccBankNo', },
        { title: '账户户名', dataIndex: 'balanceAccName', },
     
        { title: '是否清算', dataIndex: 'clarify', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
        { title: '创建时间', dataIndex: 'createTime', render: formatTime},
        { title: '承租押金', dataIndex: 'depositAmt', },
        { title: '租赁期限起始日', dataIndex: 'beginDate', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '租赁期限截止日', dataIndex: 'endDate', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '收房合同名称', dataIndex: 'houseContractName', },
        { title: '收房合同', dataIndex: 'houseContractUrl', },
        { title: '是否建融家园项目', dataIndex: 'isJr', render: (text) => {
            return findDict(commonIsMap, text).title
        }},
        { title: '商户名称', dataIndex: 'merchantName', },
        { title: '商户简称', dataIndex: 'shortName', },
        { title: '承租月租金', dataIndex: 'payAmtByMonth', },
        { title: '业主名称', dataIndex: 'recvName', },
        { title: '业主证件类型', dataIndex: 'recvCertType', render: (text) => {
            return findDict(dicRecvCertType, text).title
        } },
        { title: '业主证件号码', dataIndex: 'recvCertNo', },
        { title: '备注', dataIndex: 'remark', },
  
        { title: '状态', dataIndex: 'status', render: (text) => {
            return findDict(dicBuildingStatus, text).title
        }},
        { title: '更新时间', dataIndex: 'updateTime', render: formatTime}
    ]

    const searchOptions = [
        { key: 'operationType', type: 'select', options: mapZJBSyncDataDetailType },
        { key: 'syncStartDate', type: 'date', placeholder: '同步开始日期' },
        { key: 'syncEndDate', type: 'date', placeholder: '同步结束日期' },
    ]
    return (
        <Modal visible={visible} title="项目详情" width={950} destroyOnClose onCancel={close} footer={<Button onClick={close}>关闭</Button>}>
            {
                (visible && defaultSearch) && (
                    <ModalScrollContainer>
                        <TableHelper initialValue={defaultSearch} columns={columns} searchOptions={searchOptions} scroll={{ x: 3000 }} request={fetchZJBSyncDataProjectInfo} />
                    </ModalScrollContainer>
                )
            }
        </Modal>
    )
}

export default forwardRef(ProjectDetailListModal)


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/components/ProjectDetailListModal.jsx